// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGetTotalUnreadMessagesCountModel,
  IMappers,
  TGetTotalUnreadMessagesCountResponse,
  TGetTotalUnreadMessagesCountResponse_1,
  TGetTotalUnreadMessagesCountResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';

export const defaultConfig: TGetTotalUnreadMessagesCountModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'chats',
  pathApi: '/v1/get-total-unread-messages-count/',
} as TGetTotalUnreadMessagesCountModel;

export function createGetTotalUnreadMessagesCountModel(): TGetTotalUnreadMessagesCountModel {
  return {
    ...defaultConfig,
  };
}

export interface IGetTotalUnreadMessagesCountOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchGetTotalUnreadMessagesCount<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IGetTotalUnreadMessagesCountOptions<TResponse200, TResponse400>): Promise<
  TGetTotalUnreadMessagesCountResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetTotalUnreadMessagesCountModel(), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TGetTotalUnreadMessagesCountResponse_1);
    }
    if (statusCode === 400) {
      return mappers[400](response as TGetTotalUnreadMessagesCountResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetTotalUnreadMessagesCountResponse;
}
